// extracted by mini-css-extract-plugin
var _1 = "Sas0l";
export { _1 as "buttons" }
